// eslint-disable-next-line no-use-before-define
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const generateRandomString = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
};

const SimpleCaptcha = (props) => {
   
    const [captchaText, setCaptchaText] = useState(generateRandomString(6));
    const [userInput, setUserInput] = useState('');
    const [isValid, setIsValid] = useState(null);
    const [isUserFilledCaptcha, setIsUserFilledCaptcha] = useState(false);
    

    const regenerateCaptcha = () => {
        setCaptchaText(generateRandomString(6));
        setUserInput('');
        setIsValid(null);
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setUserInput(value);
        if(value === ""){setIsUserFilledCaptcha(true)}else{setIsUserFilledCaptcha(false)}
        if(value.length < 1){setIsValid(null); props.onValid(false); return;}
        if (value === captchaText) {
            setIsValid(true);
            props.updateCaptcha(true);
            props.onValid(true);
        } else {
            setIsValid(false);
            props.updateCaptcha(false);
            props.onValid(false);
        }
    };

    return (
        <div style={{fontSize:`${window.matchMedia("(max-width: 768px)").matches ? "20px" : "16px"}`}}> 
            <div style={{borderRadius:"0.5rem", background:"#515356", color:"white", width:"8rem", textAlign:"center"}}> 
                {captchaText}
            </div>
            <input type="text" value={userInput} onChange={handleInputChange} className='mt-3 p-1' style={{border:"1px solid #999999",borderRadius:"0.75rem", width:"8rem", textAlign:"center"}}/>
            <button className="ml-2 text-white" type='button' onClick={regenerateCaptcha} style={{backgroundColor:"#046A38",borderRadius:"0.65rem"}}>{props.language === 'hi' ? "पुनः बनाए" : "Regenerate"}</button>
            {isValid === true && <p style={{ color: 'green' }}>{props.language === 'hi' ? "कैप्चा मान्य है!" : "Captcha is valid! ✔️"}</p>}
            {isUserFilledCaptcha === true && <p style={{ color: 'red' }}>{props.language === 'hi' ? "कैप्चा भरे!" : "Enter the captcha"}</p>}
            {isValid === false && <p style={{ color: 'red' }}>{props.language === 'hi' ? "कैप्चा अमान्य है. कृपया पुन: प्रयास करें।" : "Captcha is invalid. Please try again. ❌"}</p>}
        </div>
    );
};

SimpleCaptcha.propTypes = {
  onValid: PropTypes.func,
  updateCaptcha: PropTypes.func,
  language: PropTypes.string,
};

export default SimpleCaptcha;
